import { PermissionRolesApi } from "@/api/PermissionRolesApi";
import Message from "@/const/Message";
import { Permission, SaveRoleReq } from "@/types/Permissions";
import { DialogService } from "./DialogService";

export class PermissionRolesService {
  public async getAllOptions() {
    const api = new PermissionRolesApi();
    try {
      let res = await api.getAllOptions()
      return res
    } catch (e) {
      throw e;
    }
  }

  public async save(roleId: number, permissions: Permission[]) {
    const api = new PermissionRolesApi();
    const req: SaveRoleReq = {
      roleId,
      permissions
    }
    try {
      let res = await api.save(req)
      return res
    } catch (e) {
      DialogService.error({
        title: Message.ERROR_SAVE_PERMISSIONS.DIALOG_TITLE,
      })
    }
  }

  public async getPermissionsByRoleId(roleId: number) {
    const api = new PermissionRolesApi();
    try {
      let res = await api.getPermissionsByRoleId(roleId)
      return res
    } catch (e) {
      throw e;
    }
  }

}
